var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 507,
    height: 512,
    viewBox: "0 0 507 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M470.786 0H36.1011C16.1833 0 0 16.5714 0 36.9143V475.086C0 495.429 16.1833 512 36.1011 512H470.786C490.704 512 507 495.429 507 475.086V36.9143C507 16.5714 490.704 0 470.786 0ZM153.232 438.857H78.0871V194.514H153.345V438.857H153.232ZM115.659 161.143C91.5542 161.143 72.0891 141.371 72.0891 117.143C72.0891 92.9143 91.5542 73.1429 115.659 73.1429C139.651 73.1429 159.23 92.9143 159.23 117.143C159.23 141.486 139.765 161.143 115.659 161.143ZM434.911 438.857H359.766V320C359.766 291.657 359.2 255.2 320.723 255.2C281.566 255.2 275.568 286.057 275.568 317.943V438.857H200.423V194.514H272.513V227.886H273.531C283.603 208.686 308.161 188.457 344.715 188.457C420.765 188.457 434.911 239.086 434.911 304.914V438.857Z",
    fill: "#13293D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.232 438.857H78.0871V194.514H153.345V438.857H153.232Z",
    fill: "#FCFCFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.659 161.143C91.5542 161.143 72.0891 141.371 72.0891 117.143C72.0891 92.9143 91.5542 73.1429 115.659 73.1429C139.651 73.1429 159.23 92.9143 159.23 117.143C159.23 141.486 139.765 161.143 115.659 161.143Z",
    fill: "#FCFCFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M434.911 438.857H359.766V320C359.766 291.657 359.2 255.2 320.723 255.2C281.566 255.2 275.568 286.057 275.568 317.943V438.857H200.423V194.514H272.513V227.886H273.531C283.603 208.686 308.161 188.457 344.715 188.457C420.765 188.457 434.911 239.086 434.911 304.914V438.857Z",
    fill: "#FCFCFD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.3c629ed4be73b4c1fc0ac366f55600cb.svg";
export { ForwardRef as ReactComponent };